import { IEirSalesOfferAddon } from "@modules/eirSalesFacade/interfaces/models/IEirSalesOfferAddon";
import { IEirSalesOfferAddonGroupResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesOfferAddonListResponse";

export const mapEirSalesOfferAddonList = (response: IEirSalesOfferAddonGroupResponse[]): IEirSalesOfferAddon[] =>
    response
        .sort((a, b) => a.displayOrder - b.displayOrder)
        .flatMap((addonDetail) =>
            addonDetail.addOns
                .sort((a, b) => a.displayOrder - b.displayOrder)
                .filter((addon) => addon.compatible)
                .map((addon) => ({
                    code: addon.code,
                    description: addon.description,
                    maxQuantity: addon.maxQuantity,
                    totalPrice: addon.amountVatIncluded.recurringAmount.amount,
                }))
        );
